import LabelVue from '@/views/sic/label/label.vue';

const basePath = '/sic/label';
const role = 'sic'; // 角色身份

export const SIC_LABEL_INDEX = 'sic-label-index';
export const SIC_LABEL_CREATE = 'sic-label-create';
export const SIC_LABEL_EDIT = 'sic-label-edit';
export const SIC_LABEL_SHOW = 'sic-label-show';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: LabelVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SIC_LABEL_INDEX,
      component: () => import(
        /* webpackChunkName: "label" */
        `@/views/${role}/label/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/create`,
      name: SIC_LABEL_CREATE,
      component: () => import(
        /* webpackChunkName: "label-create" */
        `@/views/${role}/label/create.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/edit/:tag_id`,
      name: SIC_LABEL_EDIT,
      props: true,
      component: () => import(
        /* webpackChunkName: "label-edit" */
        `@/views/${role}/label/edit.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/show`,
      name: SIC_LABEL_SHOW,
      props: true,
      component: () => import(
        /* webpackChunkName: "label-edit" */
        `@/views/${role}/label/show.vue`
        ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
